import React from "react";
import { Accordion, Breadcrumb, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const FAQ = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">
                Frequently Asked Questions
              </small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row className="FAQ_Spacing">
            <Col md={3} xl={3}>
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Faq_Cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={8} xl={8}>
              <div className="product_accordion">
                <Accordion alwaysOpen="true">
                  <Accordion.Item eventKey="0" className=" box_shadow">
                    <Accordion.Header>
                      What is the difference between OEM & Retail licenses?
                    </Accordion.Header>
                    <Accordion.Body>
                      OEM licenses are pre-installed on the device and are
                      backed by the vendor. Retail licenses are powered by
                      Microsoft. You are free to install your product on any
                      device. Retail versions may be transferred to new hardware
                      but may only be installed on one device at a time.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1" className=" box_shadow">
                    <Accordion.Header>
                      What is a digital download?
                    </Accordion.Header>
                    <Accordion.Body>
                      A digital download is an electronic version of your
                      software product which gives you access to download and
                      use your software immediately. This means a physical
                      package is not included with your purchase. You will have
                      the option to create a disc or USB at home or in the
                      office. Our support team would be happy to help guide you
                      through the process.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2" className=" box_shadow">
                    <Accordion.Header>
                      Will my license key expire?
                    </Accordion.Header>
                    <Accordion.Body>
                      No, any product purchased from Liberty Programs is a
                      retail version which includes a lifetime license of your
                      software.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3" className=" box_shadow">
                    <Accordion.Header>
                      How can I guarantee that my copy of Microsoft software is
                      authentic?
                    </Accordion.Header>
                    <Accordion.Body>
                      Liberty Programs only purchases and distributes software
                      and licensing keys through our trusted Microsoft Partner
                      vendors. <br />
                      Any software purchased from Liberty Programs is covered by
                      our hassle-free 90-day money-back guarantee. We encourage
                      all of our customers to register their Microsoft product
                      key via the Microsoft phone activation to ensure
                      authenticity of their purchased products.
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4" className=" box_shadow">
                    <Accordion.Header>
                      How long until I recieve my order?
                    </Accordion.Header>
                    <Accordion.Body>
                      Your order will typically be processed immediately. Please
                      login in to your account area with the credentials given
                      during the checkout process to find your download media
                      and license keys.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5" className=" box_shadow">
                    <Accordion.Header>
                      How do I download my software?
                    </Accordion.Header>
                    <Accordion.Body>
                      You can access your download media for your purchased
                      software in your account area.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6" className=" box_shadow">
                    <Accordion.Header>
                      Where can I find the license keys to activate my software
                    </Accordion.Header>
                    <Accordion.Body>
                      You can access your license key for your purchased
                      products in your account area.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="7" className=" box_shadow">
                    <Accordion.Header>
                      How do I get help with my installation?
                    </Accordion.Header>
                    <Accordion.Body>
                      We offer a step-by-step PDF document that walks you
                      through the download process . If you need more assistance
                      please contact our support team and we would be happy to
                      help you with the installation via chat or remote
                      installation.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="8" className=" box_shadow">
                    <Accordion.Header>
                      My license key is not in my account area.
                    </Accordion.Header>
                    <Accordion.Body>
                      On the rare occurrence that your product key(s) are not in
                      your account downloads area after purchase, please wait 30
                      minutes for your order to be filled or contact us for
                      immediately 24/7 support.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="9" className=" box_shadow">
                    <Accordion.Header>
                      My card was declined at checkout.
                    </Accordion.Header>
                    <Accordion.Body>
                      The most common reasons a card has been declined at
                      checkout is the billing information entered at checkout
                      does not match the information your card issuer has on
                      file. If you are certain the billing details are correct,
                      you may need to contact your card issuer to authorize the
                      payment. Or if you’re using a VPN, please disconnect while
                      making the payment. Certain IP addresses may be blocked
                      due to prior fraud from other malicious users of the VPN.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="10" className=" box_shadow">
                    <Accordion.Header>
                      What payment methods do you accept?
                    </Accordion.Header>
                    <Accordion.Body>
                      We accept Debit, VISA, MasterCard, JCB, American Express,
                      and Discover cards.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default FAQ;
